import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getItem } from '../utility/localStorageControl';
import { MenuSettings } from '../config/theme/themeVariables';

i18n.use(initReactI18next).init({
  fallbackLng: getItem(MenuSettings.RTL) ? 'ar' : 'en',
  lng: getItem(MenuSettings.RTL) ? 'ar' : 'en',
  resources: {
    ar: {
      translations: require('./localization/ar/translation.json'),
    },
    en: {
      translations: require('./localization/en/translation.json'),
    },
    esp: {
      translations: require('./localization/esp/translation.json'),
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
});

i18n.languages = ['en', 'esp', 'ar'];

export default i18n;
